import { Rule } from "antd/lib/form";

export const required: Rule = {
	required: true,
	message: "Esse campo é obrigatório",
};
